import 'babel-polyfill'
import Vue from 'vue'
import '@/plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import ViewUI from 'view-design'
import i18n from './i18n'
import '@/plugins/vue-cookie'
import '@/plugins/runtime-env'
import VueResource from 'vue-resource'
import RouterService from '@/services/RouterService'
import '@/plugins/vant'

import 'view-design/dist/styles/iview.css'
import './styles/iview-custom.less'
import './styles/vant-custom.less'
import './styles/theme/index.less'
import './scripts/svg-icon'

import VueAnalytics from 'vue-analytics'

Vue.use(VueAnalytics, {
	id: 'UA-199327188-1',
	router,
})

Vue.use(ViewUI, {
	i18n: function(path: string, options: any[] | { [key: string]: any } | undefined) {
		let value = i18n.t(path, options)
		if (value !== null && value !== undefined) {
			return value
		}
		return ''
	},
})
Vue.use(VueResource)
Vue.config.productionTip = false

//變更路由前的檢查
RouterService.beforeRoute()

new Vue({
	router,
	store,
	i18n,
	render: h => h(App),
}).$mount('#app')
